// extracted by mini-css-extract-plugin
export default {"infosCardContainer":"Intro_infosCardContainer__566md","infosCard":"Intro_infosCard__hsFVd"};